/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : CustomDataGridTableN.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { styled, Typography } from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import PropTypes from "prop-types";
import React from "react";

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  "& .MuiDataGrid-scrollbar.MuiDataGrid-scrollbar--horizontal.css-1rtad1": {
    display: "block",
  },
  "& .MuiDataGrid-columnHeaders": {
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: "bold",
    },
  },
  "& .MuiDataGrid-row": {
    cursor: "pointer",
  },
  "& .MuiDataGrid-footerContainer": {
    display: "none !important",
  },
}));

const CustomToolbar = ({ heading }) => (
  <GridToolbarContainer>
    <GridToolbarExport
      printOptions={{
        disableToolbarButton: true, // Disable the print option
      }}
    />
    {heading && <Typography sx={styles.tableHeading}>{heading}</Typography>}
  </GridToolbarContainer>
);

CustomToolbar.propTypes = {
  heading: PropTypes.node,
};

function CustomDataGridTableN({
  tableRowsData,
  columns,
  handleTableRowClick,
  isMultiLine = false,
  tableHeading,
  sx,
}) {
  const tableRowHeight = isMultiLine ? () => "auto" : () => 40;

  return (
    <StyledDataGrid
      localeText={{ toolbarDensity: "View" }}
      rows={tableRowsData}
      columns={columns}
      getRowHeight={tableRowHeight}
      disableColumnMenu
      disableColumnSelector
      disableColumnFilter
      disableRowSelectionOnClick
      slots={{ toolbar: CustomToolbar }}
      slotProps={{
        toolbar: {
          heading: tableHeading,
          printOptions: { disableToolbarButton: true },
        },
      }}
      onRowClick={(params) => handleTableRowClick({ params })}
      sx={
        sx || {
          "& .MuiDataGrid-cell": {
            ...(isMultiLine && {
              py: 1, // Add padding to cells
            }),
            borderBottom: "1px solid #e0e0e0", // Add border to cells
          },
        }
      }
    />
  );
}

CustomDataGridTableN.propTypes = {
  tableRowsData: PropTypes.array,
  columns: PropTypes.array,
  handleTableRowClick: PropTypes.func,
  isMultiLine: PropTypes.bool,
  tableHeading: PropTypes.node,
  sx: PropTypes.object,
};

export default CustomDataGridTableN;

const styles = {
  tableHeading: {
    fontSize: "18px",
    fontWeight: "bold",
    flexGrow: 1,
  },
};
